import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
import { environment } from "../../environments/environment"

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class CartService {

  constructor(private http:HttpClient) { }
  getAirOrders(request:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/order/orders",request ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }


  saledetails(request:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/finbook/saledetails/v1",request ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }

  whatsApp(id:any,request:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/sanchar/notifyorder/"+id ,request)  
  }

  emailSend(id:any,request:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/sanchar/notifyorder/email/"+id ,request)  
  }

  getOrder(id:any){
    console.log(id)
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    return this.http.get( environment.API_URL+"/api/orders/findOrderByOrderId/"+id ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }

  cancel(request:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    return this.http.post( environment.API_URL+"/api/orders/amend/new" ,request,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  cancelOrder(request:any,orderId:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    return this.http.post( environment.API_URL+"/api/order/cancel/v1/"+orderId ,request,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  cancelHotelOrder(request:any,orderId:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    if(request.cancellationType==='M'){
      return this.http.post( environment.API_URL+"/api/order/hotel/cancel/manual/v1/"+orderId ,request,{headers : header, observe : "body", params : httpParam,responseType : "json"})  

    }else{
      return this.http.post( environment.API_URL+"/api/order/hotel/cancel/v1/"+orderId ,request,{headers : header, observe : "body", params : httpParam,responseType : "json"})  

    }
  }
  cancelInsuranceOrder(request:any,orderId:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    if(request.cancellationType==='M'){
      return this.http.post( environment.API_URL+"/api/order/hotel/insurance/manual/v1/"+orderId ,request,{headers : header, observe : "body", params : httpParam,responseType : "json"})  

    }else{
      return this.http.post( environment.API_URL+"/api/order/hotel/insurance/v1/"+orderId ,request,{headers : header, observe : "body", params : httpParam,responseType : "json"})  

    }
  }
  rescheduleOrder(request:any,orderId:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    return this.http.post( environment.API_URL+"/api/postorder/amendment/reschedule/v1/"+orderId ,request,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  getAmendData(id:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    return this.http.get( environment.API_URL+"/api/orders/amend/"+id,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  getAmendHotelData(id:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    return this.http.get( environment.API_URL+"/api/orders/amend/hotel/"+id,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  saveManularCart(result:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/product/air/search/pnr/v2",result,{headers : headers,observe:"response"});
  }

  
  getSancharWhatsApp(result:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/sanchar/getwhatsappdata/"+result,{headers : headers,observe:"response"});
  }
  getSancharEmailApp(result:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/sanchar/getemaildata/"+result,{headers : headers,observe:"response"});
  }
  CSRResult(result:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/postorder/patch/issuance/v1/"+result,{headers : headers,observe:"response"});
  }
  // syncOrderItinerary(result:any){
  //   let headers = new HttpHeaders();
  //   return this.http.post(environment.API_URL+"/api/postorder/sync/issuance/v1",result,{headers : headers,observe:"response"});
  // }
    syncOrderItinerary(result:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/postorder/request/issuance/v1",result,{headers : headers,observe:"response"});
  }
  
  OrderItinerary(id:any){
    return this.http.post(environment.API_URL+"/api/order/v1/abort/"+id,{observe:"response"});
  }
  OrderReverse(id:any){
    return this.http.post(environment.API_URL+"/api/order/v1/refundProcess",id,{observe:"response"});
  }
   viewGatewayPayment(pgOrderId:any,paymentMedium:any){
    return this.http.get(environment.API_URL+"/api/pg/"+pgOrderId+"/"+paymentMedium,{observe:"response"});
  }
  patchOrderItinerary(result:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/postorder/patch/issuance/v1/"+result.orderId,result,{headers : headers,observe:"response"});
  }
  patchPassengerItinerary(result:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/postorder/manual/issuance/v1",result,{headers : headers,observe:"response"});
  }
  
  MiscellaneousItinerary(result:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/postorder/manual/v1",result,{headers : headers,observe:"response"});
  }
  UpdateHotelCart(result:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/order/hotel/book/confirm",result,{headers : headers,observe:"response"});
  }
  AmendData(request:any,id:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    return this.http.post( environment.API_URL+"/api/orders/amend/process/"+id,request,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  AmendHotelData(request:any,id:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    return this.http.post( environment.API_URL+"/api/orders/amend/hotel/process/"+id,request,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  
  AmendRescheduleData(request:any,id:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    return this.http.post( environment.API_URL+"/api/postorder/reschedule/manual/v1/"+id,request,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }

  saveCart(request:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    return this.http.post( environment.API_URL+"/api/order/v1/manuals",request,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  downloadTags(tagId:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
     httpParam=httpParam.append("name", tagId);

      return this.http.get( environment.API_URL+"/api/order/reporting/v1",{ observe : "body", params : httpParam,responseType : "blob"})  
  }
  downloadFinBookPDF(id:any,uniqueId:any){
    
    let httpParam : HttpParams=new HttpParams();

    httpParam=httpParam.append("finBookId", id);

  return this.http.get(environment.API_URL+"/api/finbook/invoice/v1", {observe : "body",params : httpParam, responseType: 'blob' })

  }

  downloadPdf(orderId:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    httpParam=httpParam.append("orderId", orderId);
    httpParam=httpParam.append("invoiceLabel", 'C');
      return this.http.get( environment.API_URL+"/api/order/hotel/voucher/v1" ,{headers : header, observe : "body", params : httpParam,responseType : "blob"})  
  }
  downloadCartPdf(orderId:any,invoiceLabel:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    httpParam=httpParam.append("orderId", orderId);
    httpParam=httpParam.append("invoiceLabel", invoiceLabel);
      return this.http.get( environment.API_URL+"/api/order/hotel/voucher/v1" ,{headers : header, observe : "body", params : httpParam,responseType : "blob"})  
  }
  downloadInsuranceCartPdf(orderId:any,invoiceLabel:any,policyNumber:any){
    let header = new HttpHeaders();
    // let httpParam : HttpParams=new HttpParams();
    // httpParam=httpParam.append("orderId", orderId);
    // httpParam=httpParam.append("invoiceLabel", invoiceLabel);
      return this.http.get( environment.API_URL+"/api/order/insurance/policy-download/"+policyNumber ,{headers : header, observe : "body",responseType : "blob"})  
  }

  calendar(result:any){

    let headers = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();

    httpParam=httpParam.append("month",result.month);
    httpParam=httpParam.append("year", result.year);

    return this.http.get(environment.API_URL+"/api/calenderlist",{headers : headers,params : httpParam,observe:"response"});
  }
 
}
